import {
    GET_PERMISSIONS,
    GET_PERMISSIONS_SUCCESS,
    CREATE_PERMISSION,
    CREATE_PERMISSION_SUCCESS,
    UPDATE_PERMISSION,
    UPDATE_PERMISSION_SUCCESS,
    INVITE_PERMISSION,
    INVITE_PERMISSION_SUCCESS
} from './constants';

/**
 *
 * @returns {{type: string}}
 */
const getPermissions = () => (
    {
        type: GET_PERMISSIONS
    }
);

/**
 *
 * @param permissions
 * @returns {{permissions: *, type: string}}
 */
const getPermissionsSuccess = (permissions) => ({
    type: GET_PERMISSIONS_SUCCESS,
    permissions
});

/**
 *
 * @param formData
 * @returns {{formData: *, type: string}}
 */
const createPermission = (formData) => ({
    type: CREATE_PERMISSION,
    formData
});

/**
 *
 * @param permissions
 * @returns {{type: string, permissions: *}}
 */
const createPermissionSuccess = (permissions) => ({
    type: CREATE_PERMISSION_SUCCESS,
    permissions
});

/**
 *
 * @param formData
 * @returns {{formData: *, type: string}}
 */
const updatePermission = (formData) => ({
    type: UPDATE_PERMISSION,
    formData
});

/**
 *
 * @param permissions
 * @returns {{type: string, permissions: *}}
 */
const updatePermissionSuccess = (permissions) => ({
    type: UPDATE_PERMISSION_SUCCESS,
    permissions
});

/**
 *
 * @param formData
 * @returns {{formData: *, type: string}}
 */
const invitePermission = (formData) => ({
    type: INVITE_PERMISSION,
    formData
});

/**
 *
 * @param permissions
 * @returns {{type: string, permissions: *}}
 */
const invitePermissionSuccess = (permissions) => ({
    type: INVITE_PERMISSION_SUCCESS,
    permissions
});

export {
    getPermissions,
    getPermissionsSuccess,
    createPermission,
    createPermissionSuccess,
    updatePermission,
    updatePermissionSuccess,
    invitePermission,
    invitePermissionSuccess
};